import React from 'react'
import { SimpleLayout } from '../layouts/simple'
import { SpecialPanel } from '../layouts/components/panel'
import { SimpleUser, User, useSwitchUser } from '../providers/context'
import { useTranslation } from '../providers/translation'
import { UserCard } from '../components/userCard'

export const AccountSwitcherPage: React.FC<{ user: User }> = ({ user }) => {
  const { tr } = useTranslation()

  return (
    <SimpleLayout footer={true}>
      <SpecialPanel className="items-stretch">
        <div className="text-3xl font-bold">{tr('You have multiple accounts')}</div>
        <div className="">{tr('Select an account from the list below to continue')}</div>
        <AccountSwitchButton user={user} className="flex cursor-pointer gap-2 rounded-lg p-2 hover:bg-gray-50" />
        {user.otherAccounts
          .filter((u) => u.canSwitchToAccount)
          .map((u) => (
            <AccountSwitchButton
              key={u.id}
              user={u}
              className="flex cursor-pointer gap-2 rounded-lg p-2 hover:bg-gray-50"
            />
          ))}
      </SpecialPanel>
    </SimpleLayout>
  )
}

interface AccountSwitchButtonProps extends React.HTMLAttributes<HTMLAnchorElement> {
  user: SimpleUser
  children?: React.ReactNode
}

export const AccountSwitchButton = React.forwardRef<HTMLAnchorElement, AccountSwitchButtonProps>(
  ({ user, children, className, ...props }, ref) => {
    const switchUser = useSwitchUser()

    return (
      <a
        {...props}
        href={`/switchAccount/${user.id}`}
        ref={ref}
        onClick={(e) => {
          e.preventDefault()
          switchUser(user.id)
        }}
        className={`${className} no-underline`}
      >
        <UserCard user={user} />
        {children}
      </a>
    )
  }
)
